import React, { useContext, useState, useEffect, useRef } from 'react'
import { filterItemsSearch, removeDuplicateInArray, formatNumber } from '../../utilities/utilities'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentInner } from '../../layout/Content'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import AutoCompleteList from '../../layout/AutoCompleteList'
import RegisterProductUnitForm from './forms/RegisterProductUnitForm'
import { registerProductControllerContext } from './RegisterProductController'
import RegisterProductInnerStyle from './css/RegisterProductInnerStyle'
import { appContext } from '../../../App'

function ProductDescriptionForm() {
  const registerProductController = useContext(registerProductControllerContext)
  const [product, setProduct] = registerProductController.product
  const { productsList } = registerProductController
  const itemBrandRef = useRef()

  const [activeInput, setActiveInput] = useState('')
  const [keyPressed, setKeyPressed] = useState('')
  const [itemClicked, setItemClicked] = useState(false)
  const [currentItemList, setCurrentItemList] = useState([])

  const onChange = (e) => {
    // avoid unwanted character's that may cause error involving regular expressions
    if (!keyPressed) return
    setActiveInput(e.target.name)
    setProduct({ ...product, [e.target.name]: e.target.value })
    const filteredItemList = filterItemsSearch(productsList.map(item => item[e.target.name]), e.target.value)
    if (filteredItemList) setCurrentItemList(filteredItemList)
  }

  const onKeyDown = (e) => {
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break;
      case 'Enter':
      case 'Tab':
      case 'Escape':
        setCurrentItemList([])
        ReactDOM.unmountComponentAtNode(document.getElementById(e.target.name+'-acl-container'))
        break
      default:
        setKeyPressed(e.key)
    }
  }

  const onBlur = (e) => {
    setActiveInput(e.target.name)
    setProduct({ ...product, [e.target.name]: product[e.target.name].trim(), [e.target.name+'_error']: (product[e.target.name].trim() === '') })
  }

  const onFocusStatusInactive = (e) => {
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (act_btn.classList.contains('show-dd-menu')) act_btn.classList.remove('show-dd-menu')
    })
  }

  useEffect(() => { itemBrandRef.current.focus() }, [])

  useEffect(() => {
    if (activeInput) {
      if (currentItemList.length > 0)
        ReactDOM.render (
          <AutoCompleteList
            valueSetter={(value) => setProduct({...product, [activeInput+'_error']: (!value), [activeInput]: value})}
            keyPressed={keyPressed}
            setItemClicked={setItemClicked}
            items={currentItemList}
          />, document.getElementById(activeInput+'-acl-container')
        )
      else
        ReactDOM.unmountComponentAtNode(document.getElementById(activeInput+'-acl-container'))

      // clear keyPressed to renew it
      if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed('')
      if (itemClicked) {
        setCurrentItemList([])
        setItemClicked(false)
      }
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyPressed, product.brand, product.name, product.description, itemClicked])

  return (
    <React.Fragment>
      <div id="register-products-form">
        <div id="item-description-container">
          <div className="form-group">
            <label htmlFor="item-brand">Brand</label>
            <div className='input-container'>
              <input
                ref={itemBrandRef}
                autoComplete="off"
                type="text"
                id="item-brand"
                name="brand"
                onChange={onChange}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
                value={product.brand}
                placeholder="Brand, trademark, manufacturer."
                className={product.brand_error ? 'item-error' : ''}
              />
              <div id='brand-acl-container' className='acl-container'></div>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="item-name">Name</label>
            <div className='input-container'>
              <input
                autoComplete="off"
                type="text"
                id="item-name"
                name="name"
                onChange={onChange}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
                value={product.name}
                placeholder="Product name, model."
                className={product.name_error ? 'item-error' : ''}
              />
              <div id='name-acl-container' className='acl-container'></div>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="item-description">Description</label>
            <div className='input-container'>
              <input type="text"
                autoComplete="off"
                id="item-description"
                name="description"
                onChange={onChange}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
                value={product.description}
                placeholder="Brief but detailed description of the product."
                className={product.description_error ? 'item-error' : ''}
              />
              <div id='description-acl-container' className='acl-container'></div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="classification">Classification</label>
            <div className='input-container'>
              <input
                autoComplete="off"
                type="text"
                id="classification"
                name="classification"
                onChange={onChange}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
                value={product.classification}
                placeholder="General classification."
                className={product.classification_error ? 'item-error' : ''}
              />
              <div id='classification-acl-container' className='acl-container'></div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="status">Status</label>
            <div id="status">
              <div id="status_active">
                <label htmlFor="item-status-active">Active</label>
                <input
                  type="radio"
                  id="item-status-active"
                  name="status"
                  value="Active"
                  onChange={() => setProduct({...product, status: 'Active'})}
                  checked={product.status === 'Active'}
                />
              </div>
              <div id="status_inactive">
                <label htmlFor="item-status-inactive">In-active</label>
                <input
                  type="radio"
                  id="item-status-inactive"
                  name="item_status"
                  value="Inactive"
                  onFocus={onFocusStatusInactive}
                  onChange={() => setProduct({...product, status: 'Inactive'})}
                  checked={product.status === 'Inactive'}
                />
              </div>
            </div>
          </div>
          {
            // check if item has error flag caused by an empty input
            // see onBlur event function
            product[activeInput+'_error'] ?
              <div className='item-error-text'>
                <FontAwesomeIcon icon='exclamation-circle'/>
                &nbsp;Please complete required fields
              </div> : null
          }
        </div>
      </div>
    </React.Fragment>
  )
}

function ItemUnitForm() {
  const app = useContext(appContext)
  const registerProductController = useContext(registerProductControllerContext)
  const { getWarehouses, productsList, updateUnit, findBarcode } = registerProductController
  const [product, setProduct] = registerProductController.product
  const itemNameBrandDescription = `${product.name} ${product.brand} ${product.description}`

  const onClickAddUnit = (e) => {
    const unit_0 = (productsList.map(product => (
      product.units.map(unit => unit.unit_name)
    )))

    let unitNameList = []
    unit_0.forEach((unit, i) => {
      if (unit) unitNameList = [...unitNameList, ...unit]
    })

    const registerProductUnitFormProps = {
      app,
      updateUnit,
      findBarcode,
      getWarehouses,
      units: product.units,
      unitNames: removeDuplicateInArray(unitNameList),
      mode: 'add'
    }

    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        height='80'
        width='50'
        header='Add New Unit'
        footer={itemNameBrandDescription}>
        <RegisterProductUnitForm { ...registerProductUnitFormProps } />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }


  const onClickEditUnit = (e) => {
    // Hide pop-up action button
    const dd_menu = e.target.closest('.dd-menu')
    const action_btn_menu = dd_menu.querySelector('.action-btn-menu')
    if (action_btn_menu.classList.contains('show-dd-menu'))
      action_btn_menu.classList.remove('show-dd-menu')

    const unit_0 = (productsList.map(product => (
      product.units.map(unit => unit.unit_name)
    )))

    let unitNameList = []
    unit_0.forEach((unit, i) => {
      if (unit) unitNameList = [...unitNameList, ...unit]
    })

    const registerProductUnitFormProps = {
      app,
      updateUnit,
      findBarcode,
      getWarehouses,
      units: product.units,
      unitNames: removeDuplicateInArray(unitNameList),
      mode: 'edit',
      unitID: dd_menu.id
    }

    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        height='80'
        width='50'
        header='Edit Unit'
        footer={itemNameBrandDescription}>
        <RegisterProductUnitForm { ...registerProductUnitFormProps } />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickDeleteUnit = (e) => {
    // Hide pop-up action button
    const dd_menu = e.target.closest('.dd-menu')
    const action_btn_menu = dd_menu.querySelector('.action-btn-menu')
    if (action_btn_menu.classList.contains('show-dd-menu'))
      action_btn_menu.classList.remove('show-dd-menu')

    const tr = e.target.parentNode.parentNode.parentNode.parentNode;
    const unit_description = tr.children[5].textContent;

    // Find out if this unit_name is currently contained in a container
    const contained = product.units.filter(unit => unit.unit_content.indexOf(unit_description) !== -1)

    if (contained.length > 0) {
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          height='30'
          header='Delete Unit'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>Cannot delete this unit.</div>
              <br />
              <div style={{marginBottom: '20px'}}>
                <span id='delete-unit-description'>{unit_description}</span> is currently in use by active container
                <span style={{display: (contained.length > 1) ? 'inline' : 'none'}}>s</span>
              </div>
              {
                contained.map((unit, index) => (
                  <div key={index} id='unit-description-container'>
                    <span>{unit.description.substr(0, unit.description.indexOf(unit_description))}</span>
                    <span><b>{unit.description.substr(unit.description.indexOf(unit_description), unit_description.length)}</b></span>
                    <span>{unit.description.substr((unit.description.indexOf(unit_description) + unit_description.length), unit.description.length)}</span>
                  </div>
                ))
              }
            </div>
            <div className='button-container'>
              <button
                onClick={() => { ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container')) }}
                className='pospro-action-btn top-anchor'>
                Ok
              </button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )

      return
    }
    setProduct({ ...product, units: product.units.filter(unit => unit.id !== dd_menu.id) })
  }

  const onClickDDButton = (e) => {
    const dd_menu = e.target.closest('.dd-menu')
    const index = parseInt(e.target.id)

    // Hide all previously oppened action buttons except the current active
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (i !== index) act_btn.classList.remove('show-dd-menu')
    })

    const action_btn_menu = dd_menu.querySelector('.action-btn-menu')
    action_btn_menu.classList.toggle('show-dd-menu')
  }

  const onDDFocus = (e) => {
    const index = parseInt(e.target.id)

    // Hide all previously oppened action buttons except the current active
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (i !== index) act_btn.classList.remove('show-dd-menu')
    })
  }

  const onFocusAddUnit = (e) => {
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (act_btn.classList.contains('show-dd-menu')) act_btn.classList.remove('show-dd-menu')
    })
  }

  return (
    <div id="item-unit-details">
      <table id="unit-details-table" className="products-list-table striped-table align-left">
        <thead>
          <tr>
            <th style={{display: 'none'}}>ID</th>
            <th>Unit Type</th>
            <th>Unit Name</th>
          <th>Contents</th>
            <th style={{textAlign: 'center'}}>Contents Quantity</th>
            <th>Description</th>
            <th style={{textAlign: 'center'}}>Vatable</th>
            <th style={{textAlign: 'center'}}>Fractional</th>
            <th style={{textAlign: 'right'}}>Capital Amount</th>
            <th style={{textAlign: 'right'}}>Wholesale Price</th>
            <th style={{textAlign: 'right'}}>Retail Price</th>
            <th style={{textAlign: 'center'}}>Status</th>
            <th></th>
          </tr>
        </thead>
        {
          product.units.map((unit, index) => (
              <tbody key={unit.id}>
                <tr>
                  <td style={{display: 'none'}}>{index}</td>
                  <td>{unit.unit_type}</td>
                  <td>{unit.unit_name}</td>
                  <td>{unit.unit_content}</td>
                  <td style={{textAlign: 'center'}}>{formatNumber(unit.contents_quantity)}</td>
                  <td>{unit.description}</td>
                  <td style={{textAlign: 'center'}}>{(unit.vatable) ? 'Yes' : 'No'}</td>
                  <td style={{textAlign: 'center'}}>{(unit.fractional) ? 'Yes' : 'No'}</td>
                  <td style={{textAlign: 'right'}}>{formatNumber(unit.capital_amount)}</td>
                  <td style={{textAlign: 'right'}}>{formatNumber(unit.wholesale_price)}</td>
                  <td style={{textAlign: 'right'}}>{formatNumber(unit.retail_price)}</td>
                  <td style={{textAlign: 'center'}}>{unit.status}</td>
                  <td>

                    <div id={unit.id} key={index} className='dd-menu'>
                      <button
                        id={index+'action-row-btn'}
                        onClick={onClickDDButton}
                        className='pospro-action-btn'
                        onFocus={onDDFocus}>
                        <FontAwesomeIcon icon='ellipsis-v'/>
                      </button>
                      <div className='action-btn-menu'>
                        <button
                          onClick={onClickEditUnit}
                          className="pospro-action-btn edit-row-btn">
                          e
                        </button>
                        <button
                          onClick={onClickDeleteUnit}
                          className="pospro-action-btn del-row-btn">
                          &times;
                        </button>
                      </div>
                    </div>


                  </td>
                </tr>
              </tbody>
          ))
        }
      </table>
      <button
        className="pospro-action-btn"
        id="add-unit-btn"
        type="button"
        onFocus={onFocusAddUnit}
        onClick={onClickAddUnit}>
        <FontAwesomeIcon icon='plus'/>&nbsp;Unit
      </button>
    </div>
  )
}

function RegisterProductInner() {
  return (
    <ContentInner>
      <ProductDescriptionForm />
      <ItemUnitForm />
      <RegisterProductInnerStyle />
    </ContentInner>
  )
}

export default React.memo(RegisterProductInner)